<template>
  <mds-card title="">
    <mds-list-group>
      <div class="schedules-tab__content">
        <mds-icon name="calendar" size="small" />
        <mds-list-group-item
          class="schedules-tab__title"
          :text="translate('flyover.feeds.schedules.card.schedule.label')"
          :microcopy="schedule.name"
        />
      </div>
      <div class="schedules-tab__content">
        <mds-icon name="refresh" size="small" />
        <mds-list-group-item
          class="schedules-tab__title"
          :text="translate('flyover.feeds.schedules.card.recurrence.label')"
          :microcopy="schedule.frequency.repeatType"
        />
      </div>
      <div class="schedules-tab__content">
        <mds-icon name="clock" size="small" />
        <mds-list-group-item
          class="schedules-tab__title"
          :text="translate('flyover.feeds.schedules.card.nextRun.label')"
          :microcopy="formattedNextRun"
        />
      </div>
    </mds-list-group>
  </mds-card>
</template>

<script>
import MdsCard from '@mds/card'
import MdsIcon from '@mds/icon'
import { MdsListGroup, MdsListGroupItem } from '@mds/list-group'
import { formatDate } from '@/utils/date'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '../../config/i18n'

export default {
  name: 'ScheduleCard',
  components: {
    MdsCard,
    MdsListGroup,
    MdsListGroupItem,
    MdsIcon,
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
    }
  },
  props: {
    schedule: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    formattedNextRun() {
      if (this.schedule.next_run_time !== 'NA' && this.schedule.next_run_time) {
        const { date, time, timezone, utcOffset } = formatDate(
          this.schedule.next_run_time
        )
        return `${date}
        <br>
        ${time} ${timezone} (${utcOffset})`
      }
      return '—'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.schedules-tab {
  &__content {
    display: flex;
    gap: $mds-space-1-x;
    width: 100%;
    flex-wrap: wrap;

    &::v-deep [class^='mds-icon'] {
      padding-top: $mds-space-quarter-x;
      width: 15px;
      height: 15px;
    }
  }
  &__title {
    margin-bottom: $mds-space-half-x;
    width: calc(100% - $mds-space-4-x);

    &::v-deep [class^='mds-list-group-item__upper'] {
      display: flex;
      > span {
        @include mds-body-text-s();
        color: $mds-text-color-primary;
      }
    }
    &::v-deep [class^='mds-list-group-item__microcopy'] {
      @include mds-body-text-s();
      color: $mds-text-color-secondary;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
